<div class="grid-biens">
  <ng-container *ngIf="listeBiens && listeBiens.length > 0">
    <div class="grid-biens-child" *ngFor="let bien of listeBiens">
      <app-card-bien [showIconPrint]="showIconPrint" [showIconPartAcc]="showIconPartAcc" [showActifPub]="showActifPub" [showIconFavorite]="showIconFavorite" [showIconOffre]="showIconOffre"
        [showIconVisite]="showIconVisite" (saveOrUpdate)="doRefreshList($event)" [btnAdmin]="btnAdmin" [bien]="bien"
        (bienClicked)="onBienClicked(bien)"></app-card-bien>
    </div>
  </ng-container>
</div>
